import React, { useContext } from 'react';

import { ModalManager } from 'ui-components/components/modal-manager';

import { Context } from './context';

const ModalManagerPortal = () => {
  const { setModalManagerRef } = useContext(Context);

  return (
    <div ref={setModalManagerRef}>
      <ModalManager />
    </div>
  );
};

export default ModalManagerPortal;
